export const permissionsIncludingPropertyOwner: AppState['permissions'] = [
  'Owner',
  'ManagedOwner',
  'FlipdishStaff',
  'StoreOwner',
  'PropertyOwner',
];

export const franchisorPermissions: AppState['permissions'] = [
  'Owner',
  'ManagedOwner',
  'FlipdishStaff',
];

// When removing store manager role directly use it in the portal and remove this permission here.
export const propertyManagerRolePermission: AppState['permissions'] = [
  'StoreManager',
  'PropertyManager',
];

// When removing store owner role directly use it in the portal and remove this permission here.
export const propertyOwnerRolePermission: AppState['permissions'] = ['StoreOwner', 'PropertyOwner'];
